import { format } from 'date-fns';
import { enUS, ru } from 'date-fns/locale';
import type { i18n } from 'i18next';

/**
 * Форматирует дату/строку в строку времени ЧЧ:ММ:СС
 * @param date - Дата для форматирования (строка, Date или число)
 * @returns Строка времени в формате ЧЧ:ММ:СС
 */
export const formatTimeOnly = (date: string | Date | number): string => {
  const dateObj = typeof date === 'string' || typeof date === 'number' ? new Date(date) : date;
  return dateObj.toLocaleTimeString('ru-RU', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
};

/**
 * Форматирует дату/строку в строку вида ЧЧ:ММ:СС ДД.ММ.ГГГГ
 * @param date - Дата для форматирования (строка, Date или число)
 * @returns Строка в формате ЧЧ:ММ:СС ДД.ММ.ГГГГ
 */
export const formatTimeDate = (date: string | Date | number): string => {
  const dateObj = typeof date === 'string' || typeof date === 'number' ? new Date(date) : date;
  const time = dateObj.toLocaleTimeString('ru-RU', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
  const dateStr = dateObj.toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
  return `${dateStr} ${time}`;
};

type FormatHumanDateOptions = {
  withTime?: boolean;
};

/**
 * Formats a date in a human-readable format based on the current locale
 * @param i18n - i18n instance from react-i18next
 * @param date - Date to format (string, Date, or number)
 * @param options - Formatting options
 * @returns Formatted date string
 */
export const formatHumanDate = (
  i18n: i18n,
  date: string | Date | number,
  options: FormatHumanDateOptions = {},
): string => {
  const { withTime = false } = options;
  const locale = i18n.language === 'ru' ? ru : enUS;

  const dateObj = typeof date === 'string' || typeof date === 'number' ? new Date(date) : date;

  if (withTime) {
    return format(dateObj, 'Pp', { locale });
  }

  return format(dateObj, 'P', { locale });
};
